module.exports = __webpack_public_path__ + "img/call-types-international.7ca7b853.svg";